import { projectSelectors } from '@projects/redux';
import { ExportTarget } from '@projects/types';
import { viewer3dSelectors } from '@viewer3D/redux';
import { useSelector } from 'react-redux';

export const useIsTelekomProject = () => {
  const projectId = useSelector(viewer3dSelectors.selectedProjectId);
  const project = useSelector(projectSelectors.selectById(projectId!));
  const isTelekomProject = project?.exportTarget === ExportTarget.Telekom;

  return { isTelekomProject };
};
